import { createFileRoute, redirect } from '@tanstack/react-router';

import { BILLING_DEFAULT_PATH } from '&/features/billing/paths';

// `/billing` has no page of its own: it lands on Invoices, the first Billing page. Guarded by the parent
// `/billing` layout (`billing:list`).
export const Route = createFileRoute('/_authenticated/billing/')({
  beforeLoad: (): void => {
    throw redirect({ to: BILLING_DEFAULT_PATH });
  },
});
